import React from 'react';
import { Col, Row } from 'react-bootstrap';
import DefaultLoader from '~/components/DefaultLoader';
import FormDefault from '~/components/FormDefault';
import { Loja } from '~/components/NovosInputs';
import Search from '~/components/Search';
import { FormProdDerivado } from './components/formProdutoDerivado';
import { FormProdOrigem } from './components/formProdutoOrigem';
import { useAjusteDePara } from './hooks/useAjusteDePara';
import { Container } from './styles';

export const AjusteDeParaContent: React.FC = () => {
  const {
    formTela: { watch, register, control, getValues, setValue },
    loading,
    showSearch,
    setShowSearch,
    setUpdate,
    isUpdate,
    onNew,
    onRowClick,
    onSave,
    resetFormData,
    handleDelete,
  } = useAjusteDePara();

  if (loading) {
    return (
      <Container>
        <DefaultLoader />
      </Container>
    );
  }

  return (
    <Container>
      {showSearch && (
        <Search codTela={322} newData={onNew} onRowClick={onRowClick} />
      )}
      {!showSearch && (
        <FormDefault
          title="Ajuste De/Para"
          codTela={322}
          codigoRegistro={[
            {
              value: watch('cod_ajuste_de_para'),
              des_campo: 'Código do Registro',
            },
          ]}
          onSave={async () => {
            await onSave();
          }}
          onCancel={() => {
            resetFormData();
            setShowSearch(true);
          }}
          isUpdate={isUpdate}
          isSave={isUpdate}
          onNew={onNew}
          onDelete={handleDelete}
          onClearFields={() => resetFormData()}
          onReturnSearch={() => {
            resetFormData();
            setUpdate(false);
            setShowSearch(true);
          }}
          labelButtonTrash="Cancelar Ajuste"
          deleteMessage="Deseja realmente cancelar o registro?"
          loadingOnSave={loading}
        >
          <Row>
            <Col sm={12} md={12}>
              <Loja
                label="Loja *"
                name="cod_loja"
                placeholder="Selecione..."
                register={register}
                control={control}
                isError={false}
                getValues={getValues}
                disabled={isUpdate}
                changeSelected={(ev) => {
                  setValue('cod_loja', ev);
                }}
              />
            </Col>
          </Row>
          <FormProdOrigem />
          <FormProdDerivado />
        </FormDefault>
      )}
    </Container>
  );
};
